var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-component"},[_c('div',{ref:"domWrap",class:`box ${_vm.getOrientation}`},[_c('v-stage',{ref:"stage",class:['konva-wrap', { preview: !_vm.enableDrag }],attrs:{"config":_vm.konvaConfig},on:{"mousedown":_vm.handleStageMouseDown,"touchstart":_vm.handleStageMouseDown}},[_c('v-layer',[_c('v-image',{attrs:{"config":{
            x: 0,
            y: 0,
            image: _vm.background,
            scaleX: _vm.canvas.scaleX,
            scaleY: _vm.canvas.scaleY,
            listening: false,
          }}}),_vm._l((_vm.avatars),function(avatar,idx){return _c('v-image',{key:`avatarc${idx}`,attrs:{"config":avatar},on:{"transformend":function($event){return _vm.handleTransformEnd($event, _vm.avatars)},"dragend":function($event){return _vm.handleDragEnd($event, _vm.avatarDraw, _vm.avatars)},"dragmove":function($event){return _vm.handleDragMove($event)}}})}),_vm._l((_vm.stamps),function(stamp,idx){return _c('v-image',{key:`stamp${idx}`,attrs:{"config":stamp},on:{"transformend":function($event){return _vm.handleTransformEnd($event, _vm.stamps)},"dragend":function($event){return _vm.handleDragEnd($event, _vm.stampDraw, _vm.stamps)},"dragmove":function($event){return _vm.handleDragMove($event)}}})}),_vm._l((_vm.textDraw),function(item,idx){return _c('v-text',{key:`text${idx}`,attrs:{"config":{
            text: item.text,
            fontSize: 25,
            fill: item.color,
            fontFamily: item.fontFamily,
            name: item.id,
            fontStyle: '100',
            rotation: +item.rotation,
            scaleX: +item.scaleX,
            scaleY: +item.scaleY,
            draggable: _vm.enableDrag,
          }},on:{"transformend":function($event){return _vm.handleTransformEnd($event, _vm.textDraw)},"dragend":function($event){return _vm.handleDragEnd($event, _vm.textDraw)},"dragmove":function($event){return _vm.handleDragMove($event)}}})}),(_vm.logo)?_c('v-image',{attrs:{"config":{
            x: 0,
            y: 0,
            scaleX: _vm.canvas.scaleX,
            scaleY: _vm.canvas.scaleY,
            image: _vm.logo,
            listening: false,
          }}}):_vm._e(),_vm._v("1 "),(_vm.getOrientation == 'landscape')?_c('v-image',{attrs:{"config":{
            x: _vm.canvas.width - 85,
            y: _vm.canvas.height - 10,
            image: _vm.backgroundCopyright,
            scaleX: 0.35,
            scaleY: 0.35,
            listening: false,
          }}}):_c('v-image',{attrs:{"config":{
            x: _vm.canvas.width - 104,
            y: _vm.canvas.height - 11,
            image: _vm.backgroundCopyright,
            scaleX: 0.35,
            scaleY: 0.35,
            listening: false,
          }}}),_c('v-transformer',{ref:"transformer",attrs:{"config":{
            borderStroke: '#FE0000',
            rotateEnabled: false,
            enabledAnchors: [],
            opacity: 1,
            padding: 2,
            centeredScaling: true,
          }}})],2)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }